import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import { getBounds } from "../../common/utils/map.js";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZGFpc3kxMjMyMSIsImEiOiJjbGhhejhjNW8wbWduM2hvaThvOTgzamdpIn0.sLKvL0-cxWSUp_8awXxiJg";

export const createMap = (container, task) => {
  return new mapboxgl.Map({
    container: container,
    style: "mapbox://styles/mapbox/satellite-v9", // style URL
    interactive: true, // Needed for mapbox-gl-draw styling
    bounds: task.latitude ? getBounds(task) : null,
    maxBounds: task.latitude ? getBounds(task) : null,
  });
};

export const showTask = (map, task) => {
  const bounds = getBounds(task);
  // Allow map to show new point
  map.setMaxBounds(bounds);
  // Move the map to the central point
  map.fitBounds(bounds, { duration: 0 });
  // Restrict map to current viewport
  map.setMaxBounds(map.getBounds());
};

export const categories = [
  // { name: "unknown", label: "Unknown", color: null },
  { name: "built", label: "Built", color: "#ef4444" },
  { name: "water", label: "Water", color: "#3b82f6" },
  { name: "trees", label: "Forest", color: "oklch(52.7% 0.154 150.069)" },
  { name: "crop", label: "Crop", color: "#FFC610" },
  { name: "grass", label: "Grassland", color: "oklch(84.1% 0.238 128.85)" },
  { name: "bare", label: "Bare", color: "#C5BAAB" },
  {
    name: "shrub_scrub",
    label: "Shrubs and Scrub",
    color: "oklch(75% 0.183 55.934)",
  },
  {
    name: "flooded_vegetation",
    label: "Flooded Vegetation & Marsh",
    color: "oklch(39.8% 0.195 277.366)",
  },
  { name: "cloud", label: "Cloud", color: "#FFFFFF" },
];

export const colorToName = Object.fromEntries(
  Object.entries(categories).map(([_, c]) => [c.color, c.name]),
);
export const colorToIndex = Object.fromEntries(
  Object.entries(categories).map(([i, c]) => [c.color, i]),
);
export const nameToColor = Object.fromEntries(
  Object.entries(categories).map(([_, c]) => [c.name, c.color]),
);

export function extractLabels(map, features) {
  return features.map((f) => {
    const fs = map.current.getFeatureState({
      source: "grid",
      id: f.id,
    });
    return { feature: f, label: colorToName[fs.color || null] };
  });
}
